import { render, staticRenderFns } from "./UpdateOrderModal.vue?vue&type=template&id=ffb9d4ca&scoped=true&"
import script from "./UpdateOrderModal.vue?vue&type=script&lang=js&"
export * from "./UpdateOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateOrderModal.vue?vue&type=style&index=0&id=ffb9d4ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb9d4ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffb9d4ca')) {
      api.createRecord('ffb9d4ca', component.options)
    } else {
      api.reload('ffb9d4ca', component.options)
    }
    module.hot.accept("./UpdateOrderModal.vue?vue&type=template&id=ffb9d4ca&scoped=true&", function () {
      api.rerender('ffb9d4ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Orders/components/UpdateOrderModal.vue"
export default component.exports